// extracted by mini-css-extract-plugin
export var container = "cBjWe";
export var copilotIconAndTitle = "vpG08";
export var denselessMargin = "bpF0V";
export var drawerBody = "QqfWV";
export var drawerContainer = "CGEDf";
export var drawerHeader = "KF_g8";
export var headerTitle = "D6UKK";
export var ssrBackground = "j7vzC";